import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wallet-transaction-report',
  templateUrl: './wallet-transaction-report.component.html',
  styleUrls: ['./wallet-transaction-report.component.scss']
})
export class WalletTransactionReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
